<template>
</template>

<script>
export default {
  name: 'socialshare',

  methods: {
    share(e) {
      const width = 500;
      const height = 300;
      const left = screen.width / 2 - width / 2;
      const top = screen.height / 2 - height / 2;
      const url = e.target.href;

      window.open(url, "", `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${width},height=${height},top=${top},left=${left}`);
    }
  }
}
</script>
